export enum BoatSailorPermission {
  SlingCreate = 'SLING_CREATE',
  FuelRequest = 'FUEL_REQUEST',
  PrepareBoat = 'PREPARE_BOAT',
  ViewBrowsingHistory = 'VIEW_BROWSING_HISTORY',
  WashingAndEngineTurn = 'WASHING_AND_ENGINE_TURNING',
  ShowContacts = 'SHOW_CONTACTS',
  Franchise_use = 'FRANCHISE_USE'
}
